module.exports = __webpack_public_path__ + "samplevideo.png";